'use client'

import {
  type MultiselectOptionItem,
  useMultiselectContext,
} from '../multiselect/use-multiselect.ts'
import { MultiselectOption } from './multiselect-option.tsx'

type MultiselectInlineOptionProps = {
  item: MultiselectOptionItem
}

const MultiselectInlineOption = ({ item }: MultiselectInlineOptionProps) => {
  const { isItemVisible, onChange, selectedItems } = useMultiselectContext()

  const visible = isItemVisible(item)

  const selected = selectedItems?.some(
    (selectedItem) => selectedItem.id === item.id
  )

  const handleClick = () => {
    if (!selectedItems) {
      onChange([item])
      return
    }

    onChange(
      selected
        ? selectedItems.filter((i) => i.id !== item.id)
        : selectedItems.concat(item)
    )
  }

  return visible ? (
    <MultiselectOption item={item} onClick={handleClick} />
  ) : null
}

export { MultiselectInlineOption }
